import {
    calculateEstimatedImpressionsRequest,
    getCampaignByIdRequest,
    getPurchasedCampaignDataFromCRM,
    getSearchLocationRequest
} from "@common";
import { FETCH_STATE_INITIAL } from "rd-redux-http";
import { Action } from "redux";
import { selectCampaignAction } from "../campaignList";
import {
    changeCampaignChangesFlagAction,
    changeSaveOrPurchaseProcessingAction,
    changeUpdateCheckTimetableFlagAction,
    changeUpdateNavStateFlagAction,
    deleteCampaignEditingDataAction,
    refreshEdititngCampaignState,
    restoreCampaignEditingDataAction,
    setPriceModelAction,
    uploadCountryListAction,
    changeRequiredDataLoadingStatusAction
} from "./actions";
import {
    campaignBudgetForm,
    campaignCreativesForm,
    campaignMediaPlanForm,
    CampaignState,
    defaultCampaignCreateState
} from "./state";
import { downloadPdfReducer } from "./download";

export function campaignReducer(state: CampaignState = defaultCampaignCreateState, action: Action): CampaignState {
    state = downloadPdfReducer(state, action);

    if (restoreCampaignEditingDataAction.is(action)) {
        return {
            ...state,
            campaignBudgetForm: action.data.budget,
            campaignCreativesForm: action.data.creatives,
            campaignMediaPlanForm: action.data.mediaPlan
        };
    }

    if (getCampaignByIdRequest.actions.isOk(action)) {
        return {
            ...state,
            editingCampaign: getCampaignByIdRequest.reducer(state.editingCampaign, action)
        };
    }

    if (setPriceModelAction.is(action)) {
        let updateCheckTimetableFlag: boolean = false;
        if (action.priceModel === "CPC") {
            updateCheckTimetableFlag = true;
        }

        return {
            ...state,
            updateCheckTimetableFlag
        };
    }

    if (getPurchasedCampaignDataFromCRM.actions.isOk(action)) {
        return {
            ...state,
            summaryCampaign: getPurchasedCampaignDataFromCRM.reducer(state.summaryCampaign, action)
        };
    }

    if (changeRequiredDataLoadingStatusAction.is(action)) {
        return {
            ...state,
            isRequiredDataLoading: action.status
        };
    }

    if (selectCampaignAction.is(action)) {
        return {
            ...state,
            editingCampaign: { fetchState: FETCH_STATE_INITIAL },
            summaryCampaign: { fetchState: FETCH_STATE_INITIAL }
        };
    }

    if (changeCampaignChangesFlagAction.is(action)) {
        return {
            ...state,
            campaignChangesFlag: action.status
        };
    }

    if (changeUpdateNavStateFlagAction.is(action)) {
        return {
            ...state,
            updateNavStateFlag: action.status
        };
    }

    if (campaignMediaPlanForm.actions.isMyAction(action)) {
        return {
            ...state,
            campaignMediaPlanForm: campaignMediaPlanForm.reducer(state.campaignMediaPlanForm, action)
        };
    }

    if (campaignCreativesForm.actions.isMyAction(action)) {
        return {
            ...state,
            campaignCreativesForm: campaignCreativesForm.reducer(state.campaignCreativesForm, action)
        };
    }

    if (campaignBudgetForm.actions.isMyAction(action)) {
        return {
            ...state,
            campaignBudgetForm: campaignBudgetForm.reducer(state.campaignBudgetForm, action)
        };
    }
    if (uploadCountryListAction.is(action)) {
        return {
            ...state,
            countryList: action.countryList
        };
    }

    if (changeUpdateCheckTimetableFlagAction.is(action)) {
        return {
            ...state,
            updateCheckTimetableFlag: action.status
        };
    }

    if (changeSaveOrPurchaseProcessingAction.is(action)) {
        return {
            ...state,
            isSaveOrPurchaseProcessing: action.isProcessing
        };
    }

    if (refreshEdititngCampaignState.is(action)) {
        return {
            ...state,
            editingCampaign: { fetchState: FETCH_STATE_INITIAL },
            summaryCampaign: { fetchState: FETCH_STATE_INITIAL }
        };
    }

    if (getSearchLocationRequest.actions.isMy(action)) {
        return {
            ...state,
            placeAndZipList: getSearchLocationRequest.reducer(state.placeAndZipList, action)
        };
    }

    if (calculateEstimatedImpressionsRequest.actions.isMy(action)) {
        return {
            ...state,
            estimatedImpression: calculateEstimatedImpressionsRequest.reducer(state.estimatedImpression, action)
        };
    }

    if (deleteCampaignEditingDataAction.is(action)) {
        return {
            ...state,
            editingCampaign: { fetchState: FETCH_STATE_INITIAL },
            estimatedImpression: { fetchState: FETCH_STATE_INITIAL },
            summaryCampaign: { fetchState: FETCH_STATE_INITIAL }
        };
    }

    return state;
}
